export default "__VITE_ASSET__B_34PvR4__"